import { Row, Card } from 'antd'
import { EmptyHeaderHero } from './components'

import PrivacyStyle from '../../styles/PrivacyPolicy.module.css'

const PrivacyPolicy = () => {
  return (
    <>
      <EmptyHeaderHero title="Privacy Policy" />
      <div className={`${PrivacyStyle["privacy-policy-screen"]}`}>
        <Row>
          <Card className={`${PrivacyStyle["privacy-policy-card"]}`}>
            <h5>Introduction:</h5>
            <p>
              Citizens United Reciprocal Exchange (CURE) strives to protect our customer&apos;s personal privacy. The information you provide to us is
              important. We understand the highly sensitive nature of the information you are providing and believe that
              earning your trust must be a high priority. We consider it of the utmost importance to safeguard this
              information in order to provide a positive and personalized insurance experience.
            </p>
            <p>
              This Privacy Policy explains how we collect and disclose the information that you provide. As with most
              websites, CURE can detect and store your IP address and that of the website that referred you to us. We
              collect such information to determine web traffic and usage patterns and use such information to help
              provide adequate capacity for our visitors to this website.
            </p>
            <p>
              Please be aware we are not able to determine your e-mail address or any other personal information unless
              you provide it to us. See further explanation below in our Privacy Policy.
            </p>

            <h5>Protecting Your Privacy:</h5>
            <p>
              This website has physical, electronic and procedural safeguards and data access controls to protect the
              sensitive personal information you provide. Our security measures protect against the loss, misuse and
              alteration of information under our control. In addition to the information contained in this Privacy Policy, the
              website Security Statement provides important information relating to your use of the website. This
              includes, for example, information regarding the use of cookies and collection of information such as IP
              address, browser and platform types, domain names, access items referral data and your activity while
              using our site. For more information, please see our
              <a className={`${PrivacyStyle["privacy-policy-hyperlinks"]}`} href="/security-policy" rel="noreferrer">
                {' '}
                Security Statement
              </a>
              .
            </p>

            <h5>Personal Information We Collect:</h5>
            <p>
              The information we collect is necessary to provide you with coverage and may come from a variety of
              sources. Personal information may include names, addresses, home telephone numbers, e-mail addresses,
              dates of birth, and social security numbers. We will also collect information pertaining to marital status
              of the applicant and the principal driver of each automobile to be insured, and information pertaining to
              the vehicle(s) to be insured, including how each vehicle is used. Information regarding licensed drivers
              to be insured, regular operators of your vehicle and other members of your household will also be
              obtained, including driving records and claims history information. Personal information may be collected
              for persons other than the individual or individuals proposed for coverage, such as other household
              members or vehicle operators who are not named insureds under a separate automobile insurance policy.
              Additionally, by applying for a CURE auto policy, you are giving us permission to confirm your motor
              vehicle record and claims history.
            </p>

            <h5>Collection of Personal Information:</h5>
            <p>
              We collect personal information that you provide through our online quoting and application process. We
              also collect information from our records and from other authorized providers of personal information. We
              order a copy of your motor vehicle record and may also seek information from authorized providers of
              claims information. These providers check to see if you have filed auto claims with other insurers. We may
              also obtain credit information where permitted by law. Although CURE does not use credit reports,
              occupation, or education level when underwriting a policy, CURE may use this information for the purpose
              of marketing and research. Some of CURE’s business partners may use this information to provide you with related services. Our sales and service representatives do not have access to the details of
              your credit information. This inquiry will not affect your credit score or credit rating. Other companies
              who view your credit report will not see the inquiry. It will be visible only to you.
            </p>

            <h5>Disclosure of Customer Information:</h5>
            <p>
              CURE will only disclose customer information as permitted or required by law. CURE will not sell
              information about you to non-affiliated companies other than to certain third-party institutions, such as
              insurance institutions, with whom we have joint marketing agreements, in order to market products and
              services that we and they offer. CURE does not sell customer information to mailing list companies or
              telemarketing companies unless the customer resides outside of the states in which CURE is licensed to
              offer its insurance products. We may enter into joint marketing agreements with other companies or request
              other companies to perform marketing services on our behalf. We strive to ensure that our business
              partners support our commitment to privacy protection in their handling of personal data about our
              policyholders. If you are a customer, we do not sell your information without your consent. However, if
              you have requested an on-line insurance quote from us, we may sell the information you provided us, such as your email address, to
              companies with whom we have joint marketing agreements so that they may follow up with you with respect to your CURE application, or so that they can provide you with additional quotes
              from those companies or the companies that they represent. As required by law, all companies participating
              in this program must sign a joint marketing agreement prohibiting the company from using your information
              for any other purpose unless you choose to purchase a policy from or through them or otherwise become their customer.
            </p>
            <p>Examples where disclosure is permitted:</p>
            <ul style={{ listStyle: 'disc', marginLeft: 24 }}>
              <li>
                <p>
                  Service companies that help CURE issue or maintain policies and handle claims, such as those who
                  appraise vehicle value, investigate and settle claims or determine eligibility for benefits or
                  payment.
                </p>
              </li>
              <li>
                <p>Companies that have entered into joint marketing agreements with CURE.</p>
              </li>
              <li>
                <p>
                  Legal and regulatory authorities. This may involve detection or prevention of criminal acts or fraud.
                </p>
              </li>
              <li>
                <p>
                  Other insurance companies or insurance support organizations in connection with an insurance
                  transaction involving you.
                </p>
              </li>
              <li>
                <p>Agents or agencies that provide insurance products.</p>
              </li>
              <li>
                <p>Various databases developed or used by the insurance industry.</p>
              </li>
              <li>
                <p>Companies who provide various consumer reports as permitted by law.</p>
              </li>
            </ul>
            <h5>Service for Your Policy:</h5>
            <p>
              CURE uses your information to conduct its business and provide insurance to you. Your personal information
              is used to generate accurate rate quotes and to help us service your policy. Disclosure of your
              information in this context is limited to those who enable us to provide insurance and customer service, investigate
              claims, prevent fraud, perform research, or comply with the applicable laws. We limit access to your
              information to our employees and others who must use the information to provide our products and services.
            </p>

            <h5>Use of Cookies:</h5>
            <p>
              A cookie is a small text file saved in your computer when you access certain web pages. Cookies identify
              you to the website that gave you the cookie. CURE uses cookies in a few areas of our site to customize and
              enhance your browsing experience by maintaining information between pages. Cookies may also be used if you
              request a rate quote from us. We do not use cookies to store or transmit any personal information about
              you. The use of cookies may, however, permit us to identify a visitor if the visitor has also provided
              identifying information. If you have set your browser to warn you before accepting cookies, you should
              receive a warning message that will allow you to refuse cookies. CUREs website requires cookies in order
              to process a rate quote.
            </p>

            <h5>Reviewing or Correcting Your Customer Information:</h5>
            <p>
              You have a right to review, update and correct your personal information by sending a written request to
              CURE, Attention: Underwriting Department, 214 Carnegie Center, Suite 301, Princeton, New Jersey 08540.
              Please describe the information that you want to review and state that your request is in response to our
              Privacy Policy. Include your full name, address and policy number (if any) in your written request. Within
              30 business days CURE will send you a summary of the information in your file. Any information that has
              been collected in expectation of or in connection with any claim, civil or criminal proceeding will be
              excluded. CURE will permit you to review and copy, in person, the recorded personal information pertaining
              to you or to obtain a copy of the recorded personal information by mail, whichever is preferred.
            </p>
            <p>
              Please let CURE know if the information is incorrect or incomplete. CURE will correct any disputed
              information that is incorrect or incomplete and provide you with a copy of the deletion, correction or
              amendment. If we do not agree that the disputed information should be corrected or deleted, we will advise
              you in writing the reasons for our refusal. We will also identify any persons to whom we have disclosed
              this personal information within the two years prior to your request. We will also identify the companies
              that have provided consumer report information about you. If a correction is made, we will also notify
              anyone who has received the information within the previous two years.
            </p>
            <p>
              If you disagree with the refusal to correct, amend or delete the personal information, you shall be
              permitted to file a statement with CURE setting forth what you think is the correct, relevant or fair
              information and a statement of the reasons why you disagree with CUREs refusal to correct, amend or delete
              the personal information. Your statement will then become part of your file. It will be sent to the same
              persons to whom we would send a copy of any correction or change. In any subsequent disclosure by CURE or
              any insurance support organization of the personal information that is subject of disagreement, we will
              clearly identify the matter or matters in dispute and provide your statement along with the personal
              information being disclosed.
            </p>

            <h5>Links to Other Websites:</h5>
            <p>
              For your convenience, CUREs website provides links to other websites that are not ours. CURE makes no
              warranties or representations about other websites or the content of any other websites linked to CURE.
              This Privacy Notice does not apply to other website&apos;s information practices. We encourage you to read
              the privacy and security policies of these linked sites when visiting them.
            </p>

            <h5>Notification of Changes:</h5>
            <p>
              We reserve the right to revise our Privacy Policy at any time. If we change our Privacy Policy,
              we will post those changes on the following website: https://www.cure.com. You may wish to visit this page
              periodically to review the most recent Privacy policy. Your continuing use of this web site
              constitutes your acceptance of any changes or updates to the Privacy Policy, all of which shall become
              controlling when posted.
            </p>

            <h5>Additional Questions:</h5>
            <p>
              If you still have questions regarding our Privacy Policy, please feel free to write to us at CURE,
              Attention: Underwriting Department, 214 Carnegie Center, Suite 301, Princeton, New Jersey 08540.
            </p>
            <hr />
            <p className={`${PrivacyStyle["privacy-policy-foot-note"]}`}>Version Date: September 18, 2024</p>
          </Card>
        </Row>
      </div>
    </>
  )
}

PrivacyPolicy.propTypes = {}

export default PrivacyPolicy
